module.exports = __webpack_public_path__ + "img/Air-FranceKLM.ebad7dce.png";